class StickyAtcs extends HTMLElement {
  constructor() {
    super();
    const target = document.querySelector(this.dataset.target);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          document.body.classList.remove('sticky-atcs--open');
        } else {
          document.body.classList.add('sticky-atcs--open');
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }
    );

    observer.observe(target);
  }

}

window.customElements.define('sticky-atcs', StickyAtcs);